import { useQuery } from '@tanstack/react-query'
import type { UnknownOutputParams } from 'expo-router'

import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

import { authApi } from '../api/authApi'
import { useEmailHash } from './useEmailHash'

const undefinedLoginDetails = {
  initialized: undefined,
  name: undefined,
  email: undefined,
  resetPasswordToken: undefined,
}

export const useLoginDetails = (searchParams: UnknownOutputParams) => {
  const emailHash = useEmailHash(searchParams)
  const { email } = filterSearchParams(searchParams)

  const { data: loginDetails, isError } = useQuery({
    queryKey: ['login_details', emailHash, email],
    queryFn: ({ signal }) => authApi.getLoginDetails({ email, emailHash }, { signal }),
    enabled: !!emailHash || !!email,
  })

  if (!emailHash && !email) return { isLoading: false, ...undefinedLoginDetails, initialized: true }
  if (isError) return { isLoading: false, ...undefinedLoginDetails, initialized: true }
  if (!loginDetails) return { isLoading: true, ...undefinedLoginDetails }
  if (loginDetails.initialized || !loginDetails.name || !loginDetails.email || !loginDetails.resetPasswordToken)
    return { isLoading: false, ...undefinedLoginDetails, initialized: true }
  return { isLoading: false, ...loginDetails }
}
